module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_6_2.82e12663.png";